/*=========================================================================================
  File Name: sidebarUiUx.js
  Description: Vuex Store - sidebar UI UX
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    updateSidebarWidth({commit}, width) {
        commit('UPDATE_SIDEBAR_WIDTH', width);
    },
    updateWindowWidth({commit}, width) {
        commit('UPDATE_WINDOW_WIDTH', width);
    },
    toggleContentOverlay({commit}) {
        commit('TOGGLE_CONTENT_OVERLAY');
    },
    updateTheme({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit('UPDATE_THEME', payload);

            axios({url: state.API_URL + '/auth/theme-settings/update', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        });
    },
};
